/** Lifecycle status returned by PDFAPI for block library headers (user-visible). */
export type BlockLifecycleStatus = 'Draft' | 'Published' | 'Archived';

/**
 * Every accepted URL/query value for the block library's status filter, including `'all'`
 * (archived rows included, unfiltered). This is the single source of truth the parser
 * (`parseBlockStatusFilter`) validates against — NOT the dropdown options list below, whose
 * narrower set is a display concern. Deriving the parser's accepted set from the options list
 * instead of this tuple was the root cause of the "Show archived reverts itself" defect: `'all'`
 * was never a valid dropdown option, so it was never a valid PARSED value either, and any
 * `?status=all` URL silently fell back to `'all-active'`.
 */
export const BLOCK_STATUS_FILTER_VALUES = ['all-active', 'all', 'Published', 'Archived'] as const;

/** UI filter values for the block library status filter. */
export type BlockStatusFilter = (typeof BLOCK_STATUS_FILTER_VALUES)[number];

/** Dropdown options for the current block library filter UI — `'all'` has no dropdown entry yet. */
export const BLOCK_STATUS_FILTER_OPTIONS: ReadonlyArray<{ value: BlockStatusFilter; label: string }> = [
  { value: 'all-active', label: 'All active' },
  { value: 'Published', label: 'Published' },
  { value: 'Archived', label: 'Archived' }
];

export const BLOCK_STATUS_LABELS: Record<BlockLifecycleStatus, string> = {
  Draft: 'Draft',
  Published: 'Published',
  Archived: 'Archived'
};

/** Sieve sort for block list queries (descending by last update). */
export const BLOCKS_LIST_DEFAULT_SORT = '-updatedAt';
